import { render, staticRenderFns } from "./DataTableNafScroll.vue?vue&type=template&id=a9ce3c50&scoped=true"
import script from "./DataTableNafScroll.vue?vue&type=script&lang=js"
export * from "./DataTableNafScroll.vue?vue&type=script&lang=js"
import style0 from "./DataTableNafScroll.vue?vue&type=style&index=0&id=a9ce3c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ce3c50",
  null
  
)

export default component.exports